import { GET_BLOG, GET_BLOGS, ADD_BLOG, ADD_BLOG_ERR, PUBLISH_BLOG, DELETE_BLOG, DISPLAY_BLOG, TOTAL_BLOG, SET_RELATED_POPUP_VISIBLE, GET_RELATED_PRODUCT, BLOG_SHARE, CONTENT_POPUP_VISIBLE, GET_BLOGS_V3, SET_BLOG_LOADING } from './type';
// import { axios } from '../common/index';
import { getErrorCode } from '../../assets/util';
import _ from 'lodash';
import queryString from 'query-string';

export function getBlogContent(id, url) {
    return function (dispatch, getState, { axios }) {
        return new Promise(resolve => {
            if (id === "undefined" && typeof url === "undefined") {
                //first time save blog
                dispatch({
                    type: GET_BLOG,
                    payload: null
                });
                resolve(null);
            } else {
                axios.get(`/get_blog`, {
                    params: {
                        id, url
                    }
                })
                    .then((response) => {
                        const temp = response.data;
                        temp.tags = _.map(temp.tag_name, (tag) => {
                            return { id: tag, tag_name: tag }
                        });
                        delete temp.tag_name;
                        dispatch({
                            type: GET_BLOG,
                            payload: temp
                        });
                        resolve(temp);
                    })
                    .catch((error) => {
                        dispatch({
                            type: GET_BLOG,
                            payload: null
                        });
                        resolve(null);
                    })
            }
        });
    }
}

export function getBlogFromStrapi(slug) {
    return function (dispatch, getState, { axStrapi }) {
        return new Promise((resolve, reject) => {

            axStrapi.get(`/blogs?slug=${slug}`)
                .then(response => {
                    const data = response.data;
                    if (data && data.length > 0) {
                        const blog = data[0];
                        dispatch({
                            type: GET_BLOG,
                            payload: { ...blog, isStrapi: true }
                        });
                        resolve(blog);
                    } else {
                        dispatch({
                            type: GET_BLOG,
                            payload: null
                        });
                        reject(new Error('Blog not found'));
                    }
                })
                .catch(error => {
                    dispatch({
                        type: GET_BLOG,
                        payload: null
                    });
                    reject(error);
                });
        });
    }
}

export function getBlogWithFallback(id) {
    return async (dispatch, getState, { axStrapi, axios }) => {
        if (!id) {
            dispatch({ type: SET_BLOG_LOADING, payload: false });
            dispatch({ type: GET_BLOG, payload: null });
            return null;
        }

        dispatch({ type: SET_BLOG_LOADING, payload: true });

        try {
            // Try Strapi first
            const response = await axStrapi.get(`/blogs?slug=${id}`);
            if (response.data && response.data.length > 0) {
                const blog = response.data[0];
                dispatch({
                    type: GET_BLOG,
                    payload: { ...blog, isStrapi: true }
                });
                dispatch({ type: SET_BLOG_LOADING, payload: false });
                return blog;
            }
        } catch (error) {
            // If Strapi fails, try legacy API
            try {
                const response = await axios.get(`/get_blog`, {
                    params: { id }
                });
                if (response.data) {
                    const temp = response.data;
                    temp.tags = _.map(temp.tag_name, (tag) => {
                        return { id: tag, tag_name: tag }
                    });
                    delete temp.tag_name;
                    dispatch({
                        type: GET_BLOG,
                        payload: temp
                    });
                    dispatch({ type: SET_BLOG_LOADING, payload: false });
                    return temp;
                }
            } catch (error) {
                dispatch({
                    type: GET_BLOG,
                    payload: null
                });
                dispatch({ type: SET_BLOG_LOADING, payload: false });
                return null;
            }
        }

        dispatch({
            type: GET_BLOG,
            payload: null
        });
        dispatch({ type: SET_BLOG_LOADING, payload: false });
        return null;
    }
}
//Fetch blog and search blog
export function getBlogs(search, type, order, page) {
    return function (dispatch, getState, { axios }) {
        //SEARCH
        const params = {};
        params.sort_type = type;
        params.sort_order = order;
        params.search_data = search;
        params.page = page;

        if (search !== '' && search) {
            params.search_data = search;
        }
        // if(search !== '' && search !== null){
        // console.log("SEARCH CALLED")
        axios.post(`/get_blogs`, params, {
            headers: {
                authorization: localStorage.getItem('token')
            }
        })
            .then((response) => {
                // console.log (response);
                dispatch({
                    type: GET_BLOGS,
                    payload: { blogs: response.data, sortColumn: type, sortOrder: order, search: search, curPage: page }
                });
            })
            .catch((error) => {
                // console.log (error);
                dispatch({
                    type: GET_BLOGS,
                    payload: null
                });
            })
    }
};

export function setRelatedPopupVisible(value) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: SET_RELATED_POPUP_VISIBLE,
            payload: value
        })
    }
}

export function saveBlog(data) {

    return (dispatch, getState, { axios }) => {
        dispatch({
            type: ADD_BLOG,
            payload: { blog_id: null, addResult: null }
        })
        const dataToInsert = {
            blog_title: data.blog_title,
            contents: data.content,
            cover_image: data.cover_image,
            status: data.status,
            tags: data.tags,
            blog_key: data.blog_key,
            relate_items: data.relate_items,
            blog_url: data.blog_url,
            published_date: data.published_date,
        };

        if (typeof data.blog_id !== "undefined" && data.blog_id !== null) {
            dataToInsert.blog_id = data.blog_id;
        }
        axios.post(`/save_blog`, dataToInsert, {
            headers: {
                authorization: localStorage.getItem('token')
            }
        })
            .then((response) => {
                dispatch({
                    type: ADD_BLOG,
                    payload: { addResult: true }
                });
            })
            .catch((error) => {
                dispatch({
                    type: ADD_BLOG_ERR,
                    payload: getErrorCode(error)
                })
                dispatch({
                    type: ADD_BLOG,
                    payload: { blog_id: null, addResult: false }
                });
            })
    }
}

export function publishBlog(data, blog_contents) {
    // console.log("KEY",data.blog_key)
    // console.log("ID",id)
    // console.log("DATA", data)
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: PUBLISH_BLOG,
            payload: { publishResult: null }
        });

        const dataToInsert = {
            blog_id: data.blog_id,
            blog_key: data.blog_key,
            blog_title: data.blog_title,
            contents: blog_contents,
            cover_image: data.cover_image,
            published_date: data.published_date,
            tags: data.tags,
            blog_url: data.blog_url,
        };
        axios.post(`/publish_blog`, dataToInsert, {
            headers: {
                authorization: localStorage.getItem('token')
            }
        })
            .then((response) => {
                // console.log (response);
                dispatch({
                    type: PUBLISH_BLOG,
                    payload: { publishResult: true }
                });
            })
            .catch((error) => {
                // console.log (error);
                dispatch({
                    type: PUBLISH_BLOG,
                    payload: { publishResult: false }
                });
            })
    }
}

export function deleteBlog(id) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: DELETE_BLOG,
            payload: { deleteResult: null }
        })
        axios.post(`/delete_blog`, { blog_id: id })
            .then((response) => {
                // console.log (response);
                dispatch({
                    type: DELETE_BLOG,
                    payload: { deleteResult: true }
                })
            })
            .catch((error) => {
                // console.log (error);
                dispatch({
                    type: DELETE_BLOG,
                    payload: { deleteResult: false }
                })
            })
    }
}

export function displayBlog(numblog, page, sort, order) {
    return (dispatch, getState, { axios }) => {
        new Promise(resolve => {
            const displaySetting = {
                numBlog: numblog,
                page: page,
                sort_type: sort,
                sort_order: order
            }
            axios.post(`/display_blog`, displaySetting)
                .then((response) => {
                    // console.log ("Display Blog response:", response.data);
                    dispatch({
                        type: DISPLAY_BLOG,
                        payload: { blogs: response.data, curPage: page, sortType: sort, sortOrder: order }
                    });
                    resolve();
                })
                .catch((error) => {
                    // console.log (error);
                    dispatch({
                        type: DISPLAY_BLOG,
                        payload: null
                    });
                    resolve();
                })
        })

    }
}

export function getTotalBlogs(id) {
    // console.log("GetTotalBlog =>", id)
    return (dispatch, getState, { axios }) => {
        axios.post(`/total_blog`, {
            id: id,
        }, {
            headers: {
                authorization: localStorage.getItem('token')
            }
        })
            .then((response) => {
                // console.log ("response total blog:", response.data);
                dispatch({
                    type: TOTAL_BLOG,
                    payload: response.data
                });
            })
            .catch((error) => {
                // console.log (error);
                dispatch({
                    type: TOTAL_BLOG,
                    payload: null
                });
            })
    }
}

export function getRelatedProduct(keyword) {
    return (dispatch, getState, { axios }) => {
        if (keyword === "") {
            dispatch({
                type: GET_RELATED_PRODUCT,
                payload: null,
            });
        }
        axios.get(`/related_product`, {
            params: {
                keyword
            },
            headers: {
                authorization: localStorage.getItem('token')
            }
        })
            .then((response) => {
                // console.log ("response:", response.data);
                dispatch({
                    type: GET_RELATED_PRODUCT,
                    payload: response.data
                });
            })
            .catch((error) => {
                // console.log (error);
                dispatch({
                    type: GET_RELATED_PRODUCT,
                    payload: null
                });
            })
    }
}

export function blogShare(blog_url, platform, share, total_share) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: BLOG_SHARE,
            payload: null
        });
        axios.post(`/blog_share`, {
            blog_url, platform, share, total_share
        })
            .then((response) => {
                dispatch({
                    type: BLOG_SHARE,
                    payload: true
                })
            })
            .catch((error) => {
                dispatch({
                    type: BLOG_SHARE,
                    payload: false
                })
            })
    }
}

export function clearBlog() {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: GET_BLOG,
            payload: null
        });
    }
}

//New blog function below this line
export function toggleContentPopup(value, index, content = null) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: CONTENT_POPUP_VISIBLE,
            payload: { value, index, content }
        });
    }
}

export function getBlogsV3({ limit = 4, page = 1, filter = {}, sort = 'latest' } = {}) {
    return (dispatch, getState, { axios }) => {
        return new Promise((resolve, reject) => {
            // Build query parameters
            const queryParams = {
                limit,
                page,
                sort
            };

            // Add filter parameters if provided
            if (filter.mat_no || filter.item_id) {
                queryParams.filter = {};
                if (filter.mat_no) {
                    queryParams.filter.mat_no = filter.mat_no;
                }
                if (filter.item_id) {
                    queryParams.filter.item_id = filter.item_id;
                }
            }

            const queryStringified = queryString.stringify(queryParams, { arrayFormat: 'bracket' });

            axios.get(`/v3/blogs/find?${queryStringified}`)
                .then((response) => {
                    dispatch({
                        type: GET_BLOGS_V3,
                        payload: response.data
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    dispatch({
                        type: GET_BLOGS_V3,
                        payload: null
                    });
                    reject(error);
                });
        });
    }
}